import { RootState, useSelector } from '../redux/store';
import { Autocomplete, TextField } from '@mui/material';
import { DeviceTag } from '../@types/model/user';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { deviceTagsState, getDeviceTags } from 'recoil/deviceTagState';
import { useRecoilValue, useSetRecoilState } from 'recoil';

interface DeviceGroupPickerProps {
  deviceGroupGuid: string | undefined;
  changeHandler: (deviceGroupGuid: string | null) => void;
  deviceTags: DeviceTag[];
}

const DeviceGroupPicker = (props: DeviceGroupPickerProps) => {
  const { t } = useTranslation(['translation', 'custom']);
  const { loaded, deviceTags } = useSelector((state: RootState) => state.user);
  const [deviceTagsGood, setDeviceTagsGood] = useState<DeviceTag[]>([]);

  useEffect(() => {
    if (props.deviceTags.length > 0) {
      setDeviceTagsGood(props.deviceTags.filter((dt) => dt.attributes.type === 'group'));
    } else {
      setDeviceTagsGood(deviceTags);
    }
  }, [props]);

  if (!loaded) {
    return null;
  }

  return (
    <Autocomplete
      disablePortal
      sx={{ minWidth: '200px' }}
      autoHighlight
      value={
        props.deviceGroupGuid
          ? deviceTagsGood.find((dt: DeviceTag) => dt.guid === props.deviceGroupGuid)
          : null
      }
      options={deviceTagsGood}
      onChange={(event, values) => props.changeHandler(values ? values.guid : null)}
      getOptionLabel={(option) => {
        return option.attributes.name;
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.guid}>
          {option.attributes.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('device_groups', { ns: 'custom' })}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password'
          }}
        />
      )}
    />
  );
};

export default DeviceGroupPicker;
